import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

export const automatedUserProvisioningNRO: NavigationRoutingObject = {
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("automated-user-provisioning", "SCIM Provisioning"),
  pageNameForTracking: () => "SCIM Provisioning",
  getDeveloperNavigationAllowed: ({ hasPermission }) => {
    return hasPermission("company", {
      permission: "admin",
    });
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("automated-user-provisioning-alt-keyword-1", "SCIM Token"),
        t("automated-user-provisioning-alt-keyword-2", "IP allowlisting"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
